import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SmartPaymentSolutionService {
  private url = environment.api;

  constructor(private http: HttpClient) {}

  /**
   * Calls GET /api/v1/smart-payment-solutions/{shortLink}
   * Returns the configuration data for the specified smart payment solution.
   */
  public getSmartPaymentSolution(shortLink: string): Observable<any> {
    if (!shortLink) {
      throw new Error('shortLink is required');
    }
    const endpoint = `${this.url}/api/v1/smart-payment-solutions/${shortLink}`;
    console.log('[SmartPaymentSolutionService] fetching smart payment solution:', endpoint);
    return this.http.get(endpoint);
  }

  /**
   * Calls GET /api/v1/smart-payment-solutions/by-order/{orderId}
   * Same payload as the short link lookup, resolved from the order id instead.
   * Requires authentication (the order id is guessable from a correlative).
   */
  public getSmartPaymentSolutionByOrder(orderId: string): Observable<any> {
    if (!orderId) {
      throw new Error('orderId is required');
    }
    const endpoint = `${this.url}/api/v1/smart-payment-solutions/by-order/${orderId}`;
    console.log('[SmartPaymentSolutionService] fetching smart payment solution by order:', endpoint);
    return this.http.get(endpoint);
  }
}
